<template>
  <footer class="portal-footer">
    <div class="portal-footer__main">
      <div class="home-shell portal-footer__main-inner">
        <div class="portal-footer__brand-col">
          <router-link to="/" class="portal-footer__brand">
            <img src="/favicon.svg" width="32" height="32" alt="" aria-hidden="true" />
            장기요양지원센터
          </router-link>
          <p class="portal-footer__org">
            장기요양기관의 급여·회계·운영 업무를 지원합니다. 운영: (주)함우리 · 카이온
          </p>
          <div class="portal-footer__contact">
            <span>상담 운영</span>
            <strong>평일 09:30 – 17:30</strong>
            <a :href="`mailto:${COMPANY.email}`">{{ COMPANY.email }}</a>
          </div>
          <router-link
            to="/mall"
            target="_blank"
            rel="noopener noreferrer"
            class="portal-footer__mall-link"
          >
            함우리몰 바로가기
          </router-link>
        </div>
      </div>
    </div>

    <!-- ============ Footer 하단 (법적 고지) ============ -->
    <div class="portal-footer__bottom">
      <div class="home-shell portal-footer__bottom-inner">
        <p class="portal-footer__biz">
          {{ COMPANY.legalName }} · 대표 {{ COMPANY.owner }} · 사업자등록번호
          <a :href="BIZ_INFO_URL" target="_blank" rel="noopener noreferrer">{{ COMPANY.bizNumber }}</a>
          · {{ COMPANY.address }}
          · 대표번호 <a :href="`tel:${COMPANY.phone.replace(/-/g, '')}`">{{ COMPANY.phone }}</a>
          · <a :href="`mailto:${COMPANY.email}`">{{ COMPANY.email }}</a>
        </p>
        <div class="portal-footer__bottom-row">
          <p class="portal-footer__copy">© {{ year }} {{ COMPANY.name }}. All rights reserved.</p>
          <nav class="portal-footer__legal" aria-label="약관">
            <router-link
              v-for="item in PORTAL_LEGAL_LINKS"
              :key="item.to"
              :to="item.to"
              :class="{ 'portal-footer__legal-strong': item.strong }"
            >
              {{ item.label }}
            </router-link>
            <a :href="BIZ_INFO_URL" target="_blank" rel="noopener noreferrer">사업자정보확인</a>
          </nav>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { BIZ_INFO_URL, COMPANY, PORTAL_LEGAL_LINKS } from '@/constants/legalContent'

const year = new Date().getFullYear()
</script>

<style lang="scss" src="./PortalFooter.scss"></style>
